import React from "react";
import Typography from "@mui/material/Typography";

// Style
import Styles from "./Home.module.css";

// Custom Components
import ActivityComponent from "./ActivityComponent/ActivityComponent";
import ExcellenceProgram from "./ExcellenceProgram/ExcellenceProgram";
import ActivityBar from "../../components/Reusable/ActivityBar/ActivityBar";

// Breadcrumbs Data
const breadcrumbs = [<Typography key="1"></Typography>];

const Home: React.FC = () => {
  return (
    <>
      {/* Activity Bar */}
      {/* <ActivityBar breadcrumbs={breadcrumbs} /> */}
      {/* Main Content */}
      <div className={Styles.container}>
        <ExcellenceProgram />
        <ActivityComponent />
      </div>
    </>
  );
};

export default Home;
